import $ from 'jquery';

$(document).ready(() => {
  const toTopButton = $('#scroll-to-top');

  window.addEventListener('scroll', function() {
    if ($(window).scrollTop() > 300) {
      toTopButton.fadeIn();
    } else {
      toTopButton.fadeOut();
    }
  });

  toTopButton.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, '300');
  });
});
